import _ from 'lodash';
//import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import ApDocumentUploadDialog from '../../components/Dialogs/ApIngestionDocumentUploadDialog';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import ApIngestionsContainer from '../../containers/apAutomation/ApIngestions';
import AuthUserContainer from '../../containers/AuthUser';
//import PricingPopupIcon from "../../images/icons/pricingPopup.svg";
//import documentIcon from "../../images/document.svg";

import { CircularProgress, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import EnhancedTable from '../../components/table/EnhancedTable';
import { getSharedStyles } from '../../themes';

import ErrorIcon from '../../images/icons/error.svg';
import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import invoiceIcon from '../../images/invoicePdf.svg';
import { renderApIngestionDocs } from './helper';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const apColumns = [
	{
		sortId: 'apIngestionId',
		displayId: 'apIngestionId',
		labels: ['AP Ingestion ID'],
	},
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Date Uploaded',
	},
	{
		noSort: true,
		sortId: 'documentResourceId',
		displayId: 'originalDocumentDisplay',
		label: 'Original PDF',
	},
	{
		sortId: 'ingestionStatus',
		displayId: 'ingestionStatusDisplay',
		label: 'Ingestion Progress',
	},
	{
		sortId: 'documentInfo',
		displayId: 'documentsDisplay',
		label: 'Matched Documents',
	},
	{
		sortId: 'apIngestionResultIds',
		displayId: 'apIngestionResultIdsDisplay',
		label: 'Results Created',
	},
];

class ApIngestions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'apIngestionId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isPricingPoppedUp: false,
			apIngestionPoppedUp: undefined,

			upcomingRows: undefined,
			currentRows: undefined,
			completedRows: undefined,
			isUploadOpen: false,

			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		};
	}

	componentDidMount() {
		const { apIngestions, apIngestionSearch } = this.props;

		if (!apIngestions) {
			apIngestionSearch({});
		} else {
			this.formatApIngestions();
		}
	}

	componentDidUpdate(prevProps) {
		const { apIngestions } = this.props;
		if (prevProps.apIngestions !== apIngestions) {
			this.formatApIngestions();
		}
	}
	refreshTable = () => {
		const { apIngestionSearch } = this.props;
		this.setState({ formattedApIngestions: undefined });
		apIngestionSearch({});
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	formatApIngestions = () => {
		const { classes } = this.props;
		const { apIngestions, apIngestionDocumentMap } = this.props;
		const formattedApIngestions = [];
		apIngestions.forEach((apIngestion) => {
			const {
				apIngestionId,
				apIngestionDocumentIds,
				documentResourceId,
				dateCreated,
				ingestionStatus,
				apIngestionResultIds = [],
				ingestionStatusMessage,
			} = apIngestion;

			apIngestion.key = apIngestionId;
			apIngestion.apIngestionResultIdsDisplay = apIngestionResultIds.join(', ');
			apIngestion.dateCreatedFormatted = (
				<div>
					<div>{moment(dateCreated).format('M/D/YYYY')}</div>
				</div>
			);

			if (ingestionStatus === 'complete') {
				apIngestion.ingestionStatusDisplay = (
					<>
						<span className={classes.greenCheckedIconSmall} /> Complete
					</>
				);
			} else if (ingestionStatus === 'error') {
				apIngestion.ingestionStatusDisplay = (
					<>
						<div>
							<span className={classes.errorIconSmall} /> Error
						</div>
						<div>{ingestionStatusMessage}</div>
					</>
				);
			} else {
				apIngestion.ingestionStatusDisplay = (
					<>
						<CircularProgress size="14px" style={{ marginRight: 4 }} />
						{_.startCase(ingestionStatus)}
					</>
				);
			}

			apIngestion.originalDocumentDisplay = (
				<div
					className={classes.invoiceIcon}
					onClick={() => {
						this.onInvoiceClick(documentResourceId);
					}}
				/>
			);

			const apIngestionDocuments = _.sortBy(
				apIngestionDocumentIds.map((apIngestionDocumentId) => {
					return apIngestionDocumentMap[apIngestionDocumentId] || null;
				}),
				'pageNumber'
			);

			if (_.isEmpty(apIngestionDocuments)) {
				apIngestion.documentsDisplay = '-';
			} else {
				apIngestion.documentsDisplay = renderApIngestionDocs({
					apIngestionDocuments,
				});
			}

			formattedApIngestions.push(apIngestion);
		});
		this.setState({ formattedApIngestions });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewFuelContract: undefined,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	showDocumentUpload = () => {
		this.setState({ isUploadOpen: true });
	};
	handleCloseUploadDialog = () => {
		this.setState({
			isUploadOpen: false,
		});
	};

	render() {
		const { classes, resourceMap } = this.props;
		const { formattedApIngestions, order, orderBy } = this.state;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>AP Ingestions</span>
							</Typography>
						</Grid>

						<Grid item xs={4} style={{ textAlign: 'right' }}>
							<Button
								variant="outlined"
								color="primary"
								className={classes.addButton}
								onClick={this.refreshTable}
								style={{ marginRight: 10 }}
							>
								Refresh Table
							</Button>
							<Button
								variant="contained"
								color="primary"
								className={classes.addButton}
								onClick={this.showDocumentUpload}
							>
								Upload AP Documents
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						{!formattedApIngestions && <div>Loading the ap ingestions...</div>}
						{formattedApIngestions && (
							<EnhancedTable
								columns={apColumns}
								rows={formattedApIngestions}
								defaultOrder={order}
								defaultOrderBy={orderBy}
							/>
						)}
						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
						<ApDocumentUploadDialog
							open={this.state.isUploadOpen}
							onClose={this.handleCloseUploadDialog}
							showErrors={this.props.showErrors}
							history={this.props.history}
							onAfterSave={this.refreshTable}
						/>

						<InvoicePdfPopup
							open={this.state.isInvoicePdfPopupOpen}
							onClose={this.handleCloseInvoicePdfPopup}
							resourceId={this.state.invoicePdfPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

ApIngestions.propTypes = {
	classes: PropTypes.object.isRequired,
	apIngestionSearch: PropTypes.func.isRequired,
	apIngestions: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	apIngestionDocumentMap: PropTypes.object,
	resourceMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	ApIngestionsContainer,
])(ApIngestions);
